import { NextSeo } from 'next-seo';
import { memo, useMemo } from 'react';

import { type PublicClip } from '@air/api';
import { useShortIdContext } from '@air/provider-short-id';

import { getClipOgImageUrl } from '~/components/Layouts/PublicBoardLayout/getClipOgImageUrl';
import { getSeoTitle, getShareSeoDescription } from '~/swr-hooks/shortUrl/utils';

export type PublicAssetSEOProps = {
  clip: Pick<PublicClip, 'id' | 'title' | 'description' | 'assets' | 'width' | 'height' | 'workspaceName'>;
};

export const PublicAssetSEO = memo(({ clip }: PublicAssetSEOProps) => {
  const { shortId } = useShortIdContext();
  const url = `https://app.air.inc/a/${shortId}`;

  const ogImageUrl = useMemo(
    () => getClipOgImageUrl(clip.assets.image, clip.width, clip.height),
    [clip.assets.image, clip.width, clip.height],
  );

  return (
    <NextSeo
      nofollow
      noindex
      title={getSeoTitle('Asset', clip.title, clip.workspaceName)}
      description={getShareSeoDescription(clip.description)}
      canonical={url}
      openGraph={{ url, images: ogImageUrl ? [{ url: ogImageUrl, alt: '' }] : undefined }}
    />
  );
});

PublicAssetSEO.displayName = 'PublicAssetSEO';
